import { useEffect, useState } from "react";
import clsx from "clsx";

interface LogoProps {
  className?: string;
}

/**
 * Logo ufficiale (frontend/public/logo.svg, estratto da winkonsupport.svg
 * caricato nel progetto — ripulito dai metadati proprietari di Illustrator,
 * inutili per il web e grandi ~3000 righe).
 *
 * Iniettato via dangerouslySetInnerHTML invece di <img src="..."> di
 * proposito: un <img> per un SVG crea un contesto di rendering isolato che
 * NON eredita i font caricati dalla pagina (Montserrat, vedi index.html) —
 * il testo "support" dentro il logo cadrebbe su un font generico. Iniettato
 * nel DOM della pagina, eredita Montserrat normalmente. Contenuto da un
 * nostro stesso file statico, non input utente — stessa logica di sicurezza
 * già usata per l'anteprima dei template email.
 */
export function Logo({ className }: LogoProps) {
  const [svgMarkup, setSvgMarkup] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch("/logo.svg")
      .then((res) => (res.ok ? res.text() : Promise.reject()))
      .then((text) => {
        if (!cancelled) setSvgMarkup(text);
      })
      .catch(() => {
        if (!cancelled) setSvgMarkup(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!svgMarkup) {
    // Fallback testuale se il file non carica per qualche motivo — mai uno
    // spazio vuoto al posto del logo.
    return (
      <span className={className}>
        Wink<span className="text-accent">on</span>Support
      </span>
    );
  }

  return (
    <div
      className={clsx("[&>svg]:h-auto [&>svg]:w-full", className)}
      style={{ lineHeight: 0 }}
      dangerouslySetInnerHTML={{ __html: svgMarkup }}
    />
  );
}
